module.exports = __webpack_public_path__ + "img/lock.45ff01fc.svg";